import Constants from '../../utils/Constants';
import { NewPdnShortcut, ShortcutProps } from './Utils';

export const NewPdnApplication = () => {
  const props: ShortcutProps = {
    projectNameKey: 'NewValveManifoldProject',
    systemNameKey: 'NewValveManifoldSystem',
    systemTypeUniqueId: Constants.systemTypes.pdn.multiPart,
    autoExecAction: Constants.autoExecActions.showAddPartDialog,
    addPartDialogSelection: Constants.autoExecActions.selectApplicationAddPartDialog,
  };

  return NewPdnShortcut(props);
};
